// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAy24npHijVHYY4439qeE23Ucp2L8OjWzE",
    authDomain: "sonoma-tour.firebaseapp.com",
    databaseURL: "https://sonoma-tour.firebaseio.com",
    projectId: "sonoma-tour",
    storageBucket: "sonoma-tour.appspot.com",
    messagingSenderId: "87729264644",
    appId: "1:87729264644:web:b3aa88f652951c156d3d51",
    measurementId: "G-PJ60CEV96J"
  },
  mapboxToken: 'pk.eyJ1IjoibWF4aW11czg3NTQiLCJhIjoiY2tncmVxYm13MTI5aTJ4cDM3Nm1kZHd2ZiJ9.2j5T5zECqFQtjU47BzSlrw'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
